import React, { useState } from 'react';
import { Chip, Tooltip } from '@material-ui/core';

const ChipList = ({ items = [], getLabel = item => item, perRow = 3, maxRows = 3, moreInline = false }) => {
  const [expanded, setExpanded] = useState(false);
  if (!items.length) return '--';
  const limit = perRow * maxRows;
  const overflow = items.length > limit;
  const visible = overflow && !expanded ? items.slice(0, moreInline ? limit : limit - 1) : items;
  const hiddenCount = items.length - visible.length;
  const chips = visible.map((item, index) => {
    const label = getLabel(item);
    return (
      <Tooltip key={index} title={label} arrow>
        <Chip label={label} size="small" variant="outlined" />
      </Tooltip>
    );
  });
  const moreChip = overflow ?
      <Chip
        key="more"
        className="more-chip"
        size="small"
        color="primary"
        label={expanded ? 'Show less' : `+${hiddenCount} more`}
        onClick={() => setExpanded(!expanded)}
      /> : null;
  if (moreChip && !moreInline) chips.push(moreChip);
  const rows = [];
  for (let i = 0; i < chips.length; i += perRow) rows.push(chips.slice(i, i + perRow));
  if (moreChip && moreInline) rows[rows.length - 1] = [...rows[rows.length - 1], moreChip];
  return (
    <div className="qme-chip-list">
      {rows.map((row, index) => <div key={index} className="qme-chip-row">{row}</div>)}
    </div>
  );
};
export default ChipList;
